import styled from 'styled-components';
import { Link, useNavigate, useLocation  } from 'react-router-dom';
import React, {useState} from 'react';

const LeftMenu = () => {
    const location = useLocation();
    const isActive = (pathname: string) => {
        return location.pathname === pathname ? 'active' : '';
    };

    return (
        <>
            <Wrap className="rel">
                <Link to="/certification" className='logo-box img-box'>
                    <img src="./img/logo.png" alt=""/>
                </Link>
                <ul className="menu-box">
                    <li className='active'>
                        <Link to="/certification" className='flex aic'>
                            <span className="img-box">
                                {/* 지금은 메뉴가 1개여서 나중에 추가 메뉴가 늘어나면 기능 구현 예정 */}
                                {/* <img src="./img/ico_certificate_555.svg" alt=""/> */}
                                <img src="./img/ico_certificate_0C7477.svg" alt=""/>
                            </span>
                            <h3>증명서 발급</h3>
                        </Link>
                        <ul className='depth-2-menu-box'>
                            <li className={isActive('/certification')}>
                                <Link to="/certification">건축물 안전 인증서</Link>
                            </li>
                            <li className={isActive('/member')}>
                                <Link to="/member">건축물 안전 협회 회원증</Link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </Wrap>
        </>
    );
}

export default LeftMenu;

const Wrap = styled.div`
    width: 280px;
    min-height: 100vh;
    border-right: 1px solid ${props => props.theme.borderColor};
    box-sizing: border-box;
    background: #fff;

    .logo-box {
        width: 200px;
        margin: 28px auto 0 auto;
    }

    .menu-box {
        margin-top: 40px;

        > li > a {
            padding: 20px 28px;
            gap: 16px;
            position: relative;

            .img-box {
                width: 16px;
            }

            h3 {
                font-size: 16px;
                color: #555;
            }
        }
        > li.active > a {
            background: #E8FCFD;
            &::after {
                content: "";
                position: absolute;
                width: 5px;
                height: 100%;
                background: ${props => props.theme.mainColor1};
                top: 0;
                right: 0;
            }

            h3 {
                color: ${props => props.theme.mainColor1};
                font-weight: 700;
            }
        }

        .depth-2-menu-box > li {
            a {
                box-sizing: border-box;
                padding: 8px 28px 8px 60px;
                font-size: 15px;
                color: #777;
            }
        }
        .depth-2-menu-box > li:first-child {
            a {
                padding: 24px 28px 16px 60px;
            }
        }
        .depth-2-menu-box > li.active {
            a {
                color: ${props => props.theme.mainColor1};
                font-weight: 500;
            }
        }
    }
`